import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const BASE = "/api/rit";

const authHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
  withCredentials: true,
});

export const getAutorizados = async (params, token) => {
  const response = await axios.get(`${baseUrl}${BASE}/autorizados`, {
    ...authHeaders(token),
    params,
  });
  return response.data;
};

export const getSoportesLote = async (idEncuesta, identificaciones, token) => {
  const response = await axios.post(
    `${baseUrl}${BASE}/autorizados/soportes`,
    { idEncuesta, identificaciones },
    authHeaders(token)
  );
  return response.data.data;
};
